// import { FC } from "react";
// import { Controller } from "react-hook-form";
// import { GroupBase, OptionsOrGroups } from "react-select";
// import HubInputField from "src/components/inputType";
// import { CurrentAndPriorTreatmentProps } from "../addCase/currentAndPriorTreatment/types";

// const packOptions: OptionsOrGroups<string, GroupBase<string>> = [
//   "4,8,12 Units Titration Packs",
//   "4,8 Units Titration Packs",
//   "8,12 Units Combo Packs",
//   "4 Units Cartridges",
//   "8 Units Cartridges",
//   "12 Units Cartridges",
// ].map((pack) => ({ value: pack, label: pack })) as unknown as OptionsOrGroups<string, GroupBase<string>>;

// const quantityOptions: OptionsOrGroups<string, GroupBase<string>> = [
//   { value: "1", label: "1 Box" },
//   { value: "2", label: "2 Boxes" },
//   { value: "3", label: "3 Boxes" },
//   // { value: "4", label: "4 Boxes" },
//   // { value: "5", label: "5 Boxes" },
//   // { value: "6", label: "6 Boxes" },
//   // { value: "7", label: "7 Boxes" },
//   // { value: "8", label: "8 Boxes" },
//   // { value: "9", label: "9 Boxes" },
//   // { value: "10", label: "10 Boxes" },
// ] as unknown as OptionsOrGroups<string, GroupBase<string>>;

// const PackDropdown: FC<CurrentAndPriorTreatmentProps> = ({ control }): JSX.Element => {
//   return (
//     <>
//       <div className="col-lg-6">
//         <Controller
//           name="prescription_attributes.packaging_size"
//           control={control}
//           render={({ field, fieldState: { error } }) => (
//             <HubInputField
//               inputId="prescription_attributes.packaging_size"
//               inputLabel="Package Size"
//               isRequired={true}
//               isRowBased={true}
//               isRowInsideAnother={true}
//               field={field}
//               error={error}
//               isDropdown={true}
//               isSearchable={false}
//               inputPlaceholder="Package Size"
//               dropdownData={packOptions}
//             />
//           )}
//         />
//       </div>
//       <div className="col-lg-6">
//         <Controller
//           name="prescription_attributes.qty"
//           control={control}
//           render={({ field, fieldState: { error } }) => (
//             <HubInputField
//               inputId="prescription_attributes.qty"
//               inputLabel="Quantity & Cartridges Per Box"
//               isRequired={true}
//               isRowBased={true}
//               isRowInsideAnother={true}
//               field={field}
//               error={error}
//               isDropdown={true}
//               isSearchable={false}
//               inputPlaceholder="Select Quantity"
//               dropdownData={quantityOptions}
//             />
//           )}
//         />
//       </div>
//     </>
//   );
// };

// export default PackDropdown;


import { FC, useEffect } from "react";
import { Controller } from "react-hook-form";
import { GroupBase, OptionsOrGroups } from "react-select";
import HubInputField from "src/components/inputType";
import { CurrentAndPriorTreatmentProps } from "../addCase/currentAndPriorTreatment/types";
import { quantityOptionsByPack } from "src/constants/packOptions";

type DropdownOption = {
  value: string;
  label: string;
};

const packOptions: DropdownOption[] = [
  {
    value: "4,8,12 Units Titration Packs",
    label: "4,8,12 Units Titration Pack (1440 units = 1 box)",
  },
  {
    value: "4,8 Units Titration Packs",
    label: "4,8 Units Titration Pack (1080 units = 1 box)",
  },
  {
    value: "8,12 Units Combo Packs",
    label: "8,12 Units Combo Pack (1800 units = 1 box)",
  },
  {
    value: "4 Units Cartridges",
    label: "4 Unit Cartridges (360 units = 1 box)",
  },
  {
    value: "8 Units Cartridges",
    label: "8 Unit Cartridges (720 units = 1 box)",
  },
  {
    value: "12 Units Cartridges",
    label: "12 Unit Cartridges (1080 units = 1 box)",
  },
];

const PackDropdown: FC<CurrentAndPriorTreatmentProps> = ({ control ,watch,setValue,isCloneCase}): JSX.Element => {
  
  
  
  const selectedPack = watch("prescription_attributes.packaging_size");
  const selectedQty = watch("prescription_attributes.qty");

  useEffect(() => {    // Reset quantity if packaging size changes
    if(!isCloneCase) {
      console.log("Resetting quantity due to packaging size change"); 
      setValue("prescription_attributes.qty", "");
      setValue("prescription_attributes.number_of_boxes", 0);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPack]);

  // Auto-populate # of Boxes when qty changes
  useEffect(() => {
    if (!selectedQty) return;
    const packKey = typeof selectedPack === "object" && selectedPack && "value" in selectedPack
      ? (selectedPack as any).value
      : selectedPack;
    const match = (quantityOptionsByPack[packKey] || []).find((opt) => opt.value === String(selectedQty));
    if (match) {
      const boxCount = parseInt(match.label, 10);
      if (!isNaN(boxCount)) {
        setValue("prescription_attributes.number_of_boxes", boxCount);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedQty]);
   

  const selectedPackValue = (() => {
    if (selectedPack && typeof selectedPack === "object" && "value" in selectedPack) {
      return (selectedPack as any).value as string;
    }
    return selectedPack as string || "";
  })();

  const quantityOptions =
    quantityOptionsByPack[selectedPackValue] || [];

  return (
    <>
      <div className="col-lg-6">
        <Controller
          name="prescription_attributes.packaging_size"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <HubInputField
              inputId="prescription_attributes.packaging_size"
              inputLabel="Package Size"
              isRequired={true}
              isRowBased={true}
              isRowInsideAnother={true}
              field={field}
              error={error}
              isDropdown={true}
              isSearchable={false}
              inputPlaceholder="Package Size"
              dropdownData={
                packOptions as unknown as OptionsOrGroups<string, GroupBase<string>>
              }
            />
          )}
        />
      </div>

      <div className="col-lg-6">
        <Controller
          name="prescription_attributes.qty"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <HubInputField
              inputId="prescription_attributes.qty"
              inputLabel="Quantity & Cartridges Per Box"
              isRequired={true}
              isRowBased={true}
              isRowInsideAnother={true}
              field={field}
              error={error}
              isDropdown={true}
              isSearchable={false}
              inputPlaceholder={
                selectedPackValue
                  ? "Select Quantity"
                  : "Select Package Size First"
              }
              dropdownData={
                quantityOptions as unknown as OptionsOrGroups<string, GroupBase<string>>
              }
            />
          )}
        />
      </div>
    </>
  );
};

export default PackDropdown;
